import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { Navigate, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Get_Admin_Details } from "../adminHttpServices/adminHttpServices";
const userAuthContext = createContext();

export function UserAuthContextProvider({ children }) {
  const [userData, setuserData] = useState([]);
  const [isSidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [waiting, setwaiting] = useState(false);
  const toggleSidebar = () => {
    setSidebarCollapsed(!isSidebarCollapsed);
  };
  const navigate = useNavigate();
  const logout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, log me out!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("falcon-admin");
        navigate("/"); // or navigate to the homepage
        Swal.fire({
          toast: true,
          icon: "success",
          position: "top-end",
          title: "Logout Successful",
          showConfirmButton: false,
          timerProgressBar: true,
          timer: 3000,
        });
      }
    });
  };
  const getMyProfile = async () => {
    try {
      setwaiting(true);
      const response = await Get_Admin_Details();
      setuserData(response?.data?.results?.admin);
      setwaiting(false);
      console.log(response);
    } catch (error) {
      console.log(error.message);
    } finally {
      setwaiting(false);
    }
  };
  return (
    <userAuthContext.Provider
      value={{
        logout,
        userData,
        // isLoggedIn,
        isSidebarCollapsed,
        toggleSidebar,
        getMyProfile,
        // activeStatus,
        // waiting,
        // getMyNotifications
      }}
    >
      {children}
    </userAuthContext.Provider>
  );
}

export function useUserAuth() {
  return useContext(userAuthContext);
}
